import { Component, OnInit, inject } from "@angular/core";
import { MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { FormDialogResult } from "@app/shared/models/form-dialog.result";
import { FormDialogConfig } from "@app/shared/models/form-dialog-config.model";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FormControlService } from "@app/shared/services/form-control.service";
import { DynamicFormComponent } from "@app/shared/components/dynamic-form/dynamic-form.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "inspekt-confirm-dialog",
    templateUrl: "./form-dialog.component.html",
    styleUrls: ["./form-dialog.component.scss"],
    imports: [
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule,
        DynamicFormComponent,
        TranslateModule,
    ],
})
export class FormDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<FormDialogComponent, FormDialogResult>>(MatDialogRef);
    private formControlService = inject(FormControlService);

    public dialog: FormDialogConfig;
    public form: FormGroup;
    private initialFormValue = "";

    ngOnInit(): void {
        this.form = this.formControlService.toFormGroup(this.dialog.fields);
        this.initialFormValue = JSON.stringify(this.form.getRawValue());
    }

    public canSubmit(): boolean {
        return !!this.form && this.form.valid && this.hasChanges();
    }

    private hasChanges(): boolean {
        return JSON.stringify(this.form.getRawValue()) !== this.initialFormValue;
    }

    public ok(): void {
        this.dialog.clickedOk = true;
        this.dialogRef.close({ ok: true, data: this.form.value });
    }

    public cancel() {
        this.dialog.clickedOk = false;
        this.dialogRef.close({ ok: false, data: null });
    }
}
